/* eslint-disable no-magic-numbers */
import React from 'react';

import { Button } from '../../../../../../../../components/Clickables/Buttons/Button';
import { Text } from '../../../../../../../../components/Text/Text';
import type { MachineState, Sender } from '../../../../../../../../interfaces/machines';
import { SocialAuthButtons } from '../../../../../../components/SocialAuthButtons/SocialAuthButtons';
import type { Context, Events } from '../../../../machine/types';

import { sendOAuthSignUpEvent } from './helpers/sendOAuthSignUpEvent';

interface ISocialProviderAreaProps {
  className?: string;
  state: MachineState<Context, Events>;
  send: Sender<Events>;
}

export const SocialProviderArea = ({
  className = 'bg-sea-foam',
  state,
  send,
}: ISocialProviderAreaProps) => {
  const { isLoading, OAuth } = state.context;
  const { errors } = OAuth;

  const handleAppleClick = (): void => {
    sendOAuthSignUpEvent('SignInWithApple', 'apple', send);
  };

  const handleFacebookClick = (): void => {
    sendOAuthSignUpEvent('Facebook', 'facebook', send, 1200);
  };

  const handleGoogleClick = (): void => {
    sendOAuthSignUpEvent('Google', 'google', send);
  };

  const handleLoginClick = (): void => {
    send({ type: 'SWITCH_TO_LOGIN' });
  };

  return (
    <div className={`col-span-full flex flex-col sm:items-center md:justify-center ${className}`}>
      <div className="mt-auto flex w-full flex-col">
        <Text className="mt-7 mb-8 text-center">
          Already on Fishbrain?{' '}
          <Button
            className="text-deep-sea p-0! font-sans font-semibold"
            onClick={handleLoginClick}
            variant="buttonNone"
          >
            Log in
          </Button>
          .
        </Text>
        <SocialAuthButtons
          className="flex flex-col space-y-4"
          disabled={isLoading}
          errors={errors}
          onAppleClick={handleAppleClick}
          onFacebookClick={handleFacebookClick}
          onGoogleClick={handleGoogleClick}
          source="signup"
        />
      </div>
    </div>
  );
};
